import css from "styled-jsx/css";
import colors from "/styles/colors";

import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";

export default css`
  .social-footer-component {
    height: 103px;
    position: relative;
    background-color: ${colors["snow"]};
    font-size: 0.8125rem;
    color: ${colors["brand-gray"]};
    display: flex;
    align-items: center;

    .items-container {
      max-width: 1050px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      display: flex;
    }
    .made-with-love-sentence {
      padding-top: 5px;
      :global(.red-heart) {
        height: 12px;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) and (min-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .social-footer-component {
      .items-container {
        padding: 0 54px;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .social-footer-component {
      .made-with-love-sentence {
        display: none;
      }
    }
  }
`;
